import React from 'react'
import { object } from 'prop-types'
import LogoScroller from '@/component/Primitive/LogoScroller'

const EventLogoScrollerWidget = ({ images }) => {
  const preparedImages = images?.free || []

  return <LogoScroller logos={preparedImages} />
}

EventLogoScrollerWidget.propTypes = {
  images: object
}

export default EventLogoScrollerWidget
